import { IComponentOptions, IController, ITranscludeFunction } from "angular";
import { EmptyStateService } from "./empty-state.service";
import { IEmptyState } from "./models";

interface IEmptyStateBindings {
  emptyStateId: string;
  infoBoxesId?: string;
  backgroundColor?: string;
}

/**
 * @example <empty-state id='lists' background-color='light'>
 * @param backgroundColor "light" | "dark"
 * @param id finds the empty state data and loads it from EmptyStateService
 */

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface EmptyStateComponentCtrl extends IEmptyStateBindings {}
class EmptyStateComponentCtrl implements IController {
  emptyState: IEmptyState;
  videoDialogOpen: boolean;
  videoUrl: string;

  transcludeSlotsFilled: {
    subtext: boolean;
    actionButton: boolean;
    mainContainer: boolean;
  };

  static $inject = ["EmptyStateService", "$transclude"];

  constructor(private emptyStateService: EmptyStateService, private $transclude: ITranscludeFunction) {}

  $onInit(): void {
    this.transcludeSlotsFilled = {
      subtext: this.$transclude.isSlotFilled("subtext"),
      actionButton: this.$transclude.isSlotFilled("actionButton"),
      mainContainer: this.$transclude.isSlotFilled("mainContainer"),
    };

    this.emptyState = this.emptyStateService.getEmptyState(this.emptyStateId);
    this.videoDialogOpen = false;
  }

  openVideoDialog(videoUrl: string): void {
    this.videoUrl = this.emptyStateService.trustResource(videoUrl);
    this.videoDialogOpen = true;
  }

  closeVideoDialog(): void {
    this.videoUrl = "";
    this.videoDialogOpen = false;
  }
}

export const EmptyStateComponent: IComponentOptions = {
  controller: EmptyStateComponentCtrl,
  template: require("./empty-state.html"),
  bindings: {
    emptyStateId: "@",
    infoBoxesId: "@",
    backgroundColor: "@",
  },
  transclude: {
    subtext: "?subtext",
    actionButton: "?actionButton",
    mainContainer: "?mainContainer",
  },
};
